var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, useState } from 'react';
import { ChevronDown } from '../icon';
import { iconLeftStyle, iconRightStyle, selectStyle, selectWrapperStyle, } from './styles';
function SelectInternal(_a, ref) {
    var { children, disabled = false, error = false, iconLeft, inverted = false, onBlur, onFocus, size = 'medium', value } = _a, restProps = __rest(_a, ["children", "disabled", "error", "iconLeft", "inverted", "onBlur", "onFocus", "size", "value"]);
    const [isFocused, setIsFocused] = useState(false);
    const hasIconLeft = iconLeft !== undefined;
    function renderLeftIcon(originalIcon) {
        return originalIcon.props.size != null
            ? originalIcon
            : cloneElement(originalIcon, {
                size,
            });
    }
    function handleFocus(event) {
        if (onFocus != null) {
            onFocus(event);
        }
        setIsFocused(true);
    }
    function handleBlur(event) {
        if (onBlur != null) {
            onBlur(event);
        }
        setIsFocused(false);
    }
    return (_jsxs("div", Object.assign({ css: selectWrapperStyle({ disabled, inverted, isFocused, size }) }, { children: [hasIconLeft && (_jsx("div", Object.assign({ css: iconLeftStyle({ size }) }, { children: renderLeftIcon(iconLeft) }))), _jsx("select", Object.assign({}, restProps, { disabled, value }, { "aria-invalid": error, css: selectStyle({
                    hasError: error,
                    hasIcon: hasIconLeft,
                    size,
                    withPlaceholder: value === '' || value === 'placeholder',
                }), onBlur: handleBlur, onFocus: handleFocus, ref: ref }, { children: children })), _jsx("div", Object.assign({ css: iconRightStyle({ size }) }, { children: _jsx(ChevronDown, { size: size === 'large' ? 'medium' : size }) }))] })));
}
export default SelectInternal;
